import { getAuth } from "firebase/auth";
import {
  deleteDoc,
  getDocs,
  onSnapshot,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase/fireabase"; // import your Firestore instance
import { collection } from "firebase/firestore";
import { BsIncognito } from "react-icons/bs";
import { doc, getDoc } from "firebase/firestore";
import { MdDeleteOutline } from "react-icons/md";
import { useEffect, useState } from "react";
import NoMessagesImage from "../image/3d-casual-life-messages.png";
import { CiStar } from "react-icons/ci";
const AllMessages = () => {
  const [messages, setMessages] = useState([]);
  useEffect(() => {
    const fetchMessages = () => {
      const auth = getAuth();
      const messagesCollection = collection(
        db,
        "users",
        auth.currentUser.uid,
        "messages"
      );

      onSnapshot(messagesCollection, (snapshot) => {
        let fetchedMessages = snapshot.docs.map(async (messageDoc) => {
          let message = messageDoc.data();
          if (
            message.senderData &&
            message.senderData.senderId !== "anonymous"
          ) {
            const senderDoc = await getDoc(
              doc(db, "users", message.senderData.senderId)
            );
            const senderData = senderDoc.data();
            if (senderData) {
              message.userPhotoURL = senderData.photoURL;
            }
          }
          return { ...message, id: messageDoc.id };
        });

        Promise.all(fetchedMessages).then((messages) => {
          messages.sort((a, b) => new Date(b.ceatedAt) - new Date(a.ceatedAt));
          setMessages(messages);
        });
      });
    };

    fetchMessages();
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  // handel delete message
  const handleDeleteMessage = async (messageId) => {
    const auth = getAuth();
    await deleteDoc(
      doc(db, "users", auth.currentUser.uid, "messages", messageId)
    );
  };

  const handleStarMessage = async (messageId) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      console.error("User not authenticated");
      return;
    }

    // Reference to the original message document
    const messageRef = doc(db, "users", user.uid, "messages", messageId);

    // Fetch the original message content
    const messageSnapshot = await getDoc(messageRef);
    if (!messageSnapshot.exists()) {
      console.error("Message does not exist");
      return;
    }
    const messageData = messageSnapshot.data();

    // Step 1: Add or update the message in the "favorites" collection
    const favoritesRef = doc(db, "users", user.uid, "favorites", messageId);
    await setDoc(
      favoritesRef,
      {
        ...messageData, // Spread the original message data
        starred: true, // Ensure the starred field is set to true
      },
      { merge: true }
    );

    // Step 2: Update the `starred` field in the original message
    await updateDoc(messageRef, {
      starred: true,
    });
  };

  // handel un star message
  const handleUnStarMessage = async (messageId) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      console.error("User not authenticated");
      return;
    }

    // Reference to the original message document
    const messageRef = doc(db, "users", user.uid, "messages", messageId);

    // Fetch the original message content
    const messageSnapshot = await getDoc(messageRef);
    if (!messageSnapshot.exists()) {
      console.error("Message does not exist");
      return;
    }
    const messageData = messageSnapshot.data();

    // Step 1: Delete the message from the "favorites" collection
    const favoritesRef = doc(db, "users", user.uid, "favorites", messageId);
    await deleteDoc(favoritesRef);

    // Step 2: Update the `starred` field in the original message
    await updateDoc(messageRef, {
      starred: false,
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        width: "100%",
      }}
    >
      {messages.length === 0 && (
        <div className="flex flex-col items-center gap-5 w-full">
          <p>لا يوجد رسائل</p>
          <img
            src={NoMessagesImage}
            alt="no messages"
            className="w-full max-w-md sm:w-1/2"
            style={{ width: "200px" }}
          />
        </div>
      )}

      {messages.map(
        (message) =>
          console.log(message.starred && message.starred, "starred") || (
            <div
              key={message.id}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                boxShadow: "0px 0px 10px 0px rgba(128,128,128,0.75)",
                borderRadius: "10px",
                padding: "10px",
                margin: "10px",
                justifyContent: "start",
                gap: "20px",
              }}
              className="lg:w-1/2 w-full"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  alignItems: "start",
                  justifyContent: "start",
                  height: "100%",
                }}
                className="w-full"
              >
                <div>
                  {message.ceatedAt && (
                    <p className="flex items-center justify-start">
                      <span className="text-gray-400 text-sm pr-3 sm:block hidden">
                        تم ارسال الرسالة في:{" "}
                      </span>
                      <span className="mx-3">
                        {" "}
                        {new Date(message.ceatedAt).toLocaleString("ar-EG", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>{" "}
                    </p>
                  )}
                  <p
                    style={{
                      overflowWrap: "break-word",
                    }}
                    className="w-full text-right py-2 px-4"
                  >
                    {message.content}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column-reverse",
                    alignItems: "center",
                    justifyContent: "start",
                    gap: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#f0ad4e",
                      textAlign: "center",
                    }}
                  >
                    {message.senderData &&
                    message.senderData.senderId === "anonymous"
                      ? "مجهول"
                      : message.senderData.name || "مجهول"}
                  </p>
                  {message.senderData.senderId === "anonymous" ? (
                    <BsIncognito
                      size="40px"
                      style={{
                        color: "#f0ad4e !important",
                        backgroundColor: "#f0ad4e !important",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        message.senderData.photoURL ||
                        message.userPhotoURL ||
                        `https://api.dicebear.com/7.x/adventurer/svg?seed=${user.name}&flip=true&radius=25&skinColor=ecad80,f2d3b1&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf,transparent`
                      }
                      alt="user"
                      width="40px"
                      height="40px"
                      style={{ borderRadius: "50%" }}
                    />
                  )}
                </div>
              </div>

              <div className="flex flex-col items-center justify-center gap-5">
                <MdDeleteOutline
                  size="1.5em"
                  className="cursor-pointer"
                  onClick={() => handleDeleteMessage(message.id)}
                />
                {message.starred && message.starred ? (
                  <img
                    src="https://img.icons8.com/emoji/48/star-emoji.png"
                    alt="star-icon"
                    width="20px"
                    height="20px"
                    className="cursor-pointer"
                    onClick={() => handleUnStarMessage(message.id)}
                  />
                ) : (
                  <CiStar
                    size="1.5em"
                    className={`cursor-pointer `}
                    onClick={() => handleStarMessage(message.id)}
                  />
                )}
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default AllMessages;
